<script setup lang="ts">
import { BOOKING_URL } from '~/common/types'

const pattern = {
  'background-image': 'radial-gradient(#334155 1px, #0f172a 1px)',
  'background-size': '15px 15px',
}
</script>

<template>
  <section id="booking" class="relative">
    <div class="absolute inset-0 bg-gray-900 mix-blend-multiply"
         aria-hidden="true"
    />
    <div :style="pattern"
         class="absolute inset-0 w-full h-full text-center opacity-50"
    />
    <div class="relative z-10">
      <div class="max-w-7xl mx-auto px-4 py-8 lg:py-12 lg:flex lg:items-center lg:justify-between">
        <div class="max-w-xl">
          <span class="font-semibold text-accent-500 tracking-wider uppercase">
            {{ $t('pages.index.booking.suptitle') }}
          </span>
          <h2 class="font-heading mt-1 text-2xl font-semibold text-gray-100 md:text-3xl">
            {{ $t('pages.index.booking.title') }}
          </h2>
        </div>
        <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
          <div class="inline-flex rounded-md shadow">
            <a :href="BOOKING_URL"
               target="_blank"
               class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-gray-900 transition rounded-md bg-gray-200 hover:bg-primary-500 hover:text-white"
            >
              {{ $t('pages.index.booking.button') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
